const comments = [
  {
    id: 1,
    name: '影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20young%20Chinese%20man%20with%20warm%20lighting%2C%20soft%20background%20bokeh%2C%20friendly%20expression%2C%20professional%20headshot%20style%2C%20neutral%20backdrop%20with%20subtle%20golden%20tones&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    rating: 5,
    text: '用了大半年了，91免费在线视频资源确实丰富，更新也快。特别是晚上想看点什么的时候打开就有，画质清晰不卡顿，比很多收费站都流畅！',
  },
  {
    id: 2,
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20middle%20aged%20Chinese%20woman%20with%20warm%20cinematic%20lighting%2C%20soft%20focus%20background%2C%20gentle%20smile%2C%20professional%20headshot%2C%20neutral%20studio%20backdrop&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-26',
    rating: 4,
    text: '91精品视频在线播放的画质真的太棒了，手机看也不缓冲。推荐给了好几个朋友，都说好用。希望国产影片分类再多一些就更完美了。',
  },
  {
    id: 3,
    name: '追剧达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20young%20Chinese%20man%20with%20stylish%20look%2C%20soft%20dramatic%20lighting%2C%20blurred%20background%2C%20professional%20headshot%20style%2C%20warm%20tone%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-25',
    rating: 5,
    text: '91免费视频网站里面资源最全的就是这个了，分类清晰找片方便。每天下班回家第一件事就是打开看看有什么新片，已经成为生活习惯了。',
  },
  {
    id: 4,
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20man%20with%20glasses%2C%20warm%20cinematic%20lighting%2C%20thoughtful%20expression%2C%20soft%20background%2C%20professional%20headshot%2C%20neutral%20studio%20lighting&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2026-07-23',
    rating: 4,
    text: '作为一个看了20年电影的人，91麻豆免费视频网站的片源质量让我惊喜。很多冷门好片都能找到，高清画质还原度很高，免费又良心。',
  },
  {
    id: 5,
    name: '周末影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20natural%20lighting%2C%20bright%20smile%2C%20soft%20focus%20background%2C%20professional%20headshot%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '2026-07-21',
    rating: 5,
    text: '周末宅家必备！91在线观看免费太方便了，连注册都不用，打开就能看。91福利在线视频专区也经常更新，每次都有惊喜，强烈推荐！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">用户口碑</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">用户口碑</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            来自全国各地影迷的真实评价，你的观影感受对我们很重要
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-red-100 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const t = e.currentTarget;
                      t.style.display = 'none';
                      const p = t.parentElement;
                      if (p) {
                        p.classList.add('flex', 'items-center', 'justify-center', 'bg-red-100');
                        p.innerHTML = `<span class="text-red-600 text-sm font-bold">${comment.name.charAt(0)}</span>`;
                      }
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">{comment.name}</p>
                  <p className="text-xs text-gray-400">{comment.date}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}